import { render, staticRenderFns } from "./ReactionComboButton.vue?vue&type=template&id=7d3689de&lang=pug"
import script from "./ReactionComboButton.vue?vue&type=script&lang=ts"
export * from "./ReactionComboButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports